import { render, staticRenderFns } from "./GameMapWorld.vue?vue&type=template&id=0be931c7&scoped=true&"
import script from "./GameMapWorld.vue?vue&type=script&lang=js&"
export * from "./GameMapWorld.vue?vue&type=script&lang=js&"
import style0 from "./GameMapWorld.vue?vue&type=style&index=0&id=0be931c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be931c7",
  null
  
)

export default component.exports